import _defaultTo from 'lodash/defaultTo';
import _isNil from 'lodash/isNil';
import _map from 'lodash/map';
import _toUpper from 'lodash/toUpper';
// Serialization
import { deserialize, serialize } from 'serializr';
import { planningSchema } from './schemas';
// Custom
// Planning model (from app: most utils functions are identical)
import mPlanning from '../planning';
// Fragments
import { planningFragment, operationFragment } from './fragments';

/**
* Serialization
*/
const deserializePlanning = (data) => deserialize(planningSchema, data);

const serializePlanning = ({
  name, slots, enabled,
}) => ({
  ...serialize(planningSchema, {
    ...(!_isNil(enabled) && { enabled }),
    name: _defaultTo(name, null),
    slots,
  }),
});

/**
* Utils function for calendar management
*/
// Use planning model 'slotsToEvents' method with specific key
const slotsToEvents = (slots) => mPlanning.slotsToEvents(slots, 'dayOfWeek');

// Override eventsToSlots method as keys are not the same
const eventsToSlots = (events) => _map(mPlanning.eventsToSlots(events), ({ start, end }) => ({
  start: {
    dayOfWeek: _toUpper(start.day_of_week),
    time: start.time,
  },
  end: {
    dayOfWeek: _toUpper(end.day_of_week),
    time: end.time,
  },
}));

/**
* GraphQL
*/
const queListPlannings = `
  query ListPlannings($input: ListPlanningsInput!, $search: ListPlanningsSearchInput) {
    listPlannings(input: $input, search: $search) {
      ...planningFragment
    }
  }

  ${planningFragment}
`;

const queGetPlanning = `
  query GetPlanning($input: GetPlanningInput!) {
    getPlanning(input: $input) {
      ...planningFragment
    }
  }

  ${planningFragment}
`;

const mutAddPlanning = `
  mutation AddPlanning($input: AddPlanningInput!) {
    addPlanning(input: $input) {
      id,
      operation {
        ...operationFragment
      }
    }
  }

  ${operationFragment}
`;

const mutUpdatePlanning = `
  mutation UpdatePlanning($input: UpdatePlanningInput!) {
    updatePlanning(input: $input) {
      id,
      operation {
        ...operationFragment
      }
    }
  }

  ${operationFragment}
`;

const mutDeletePlanning = `
  mutation DeletePlanning($input: DeletePlanningInput!) {
    deletePlanning(input: $input) {
      id,
      operation {
        ...operationFragment
      }
    }
  }

  ${operationFragment}
`;

/**
* Model
*/
const planning = {
  // Use all functions from app planning model, and override only the one needed
  ...mPlanning,

  // Serialization
  deserialize: deserializePlanning,
  serialize: serializePlanning,

  // Utils
  slotsToEvents,
  eventsToSlots,

  // List features
  listFeatures: {
    // Default list param (not used)
    defaultParams: {
      pagination: {
        page: 1,
        pageSize: 20,
      },
      sort: [],
    },

    // Columns
    columnsQuantity: () => ({
      xs: 1,
      sm: 1,
      md: 1,
      lg: 1,
      xl: 1,
    }),
    columns: [
      {
        key: 'name',
        labelId: 'field.name',
        field: 'name',
        sortable: false,
      },
    ],

    // Search fields
    searchFields: [],
  },

  // GraphQL
  queListPlannings,
  queGetPlanning,
  mutAddPlanning,
  mutUpdatePlanning,
  mutDeletePlanning,
};

module.exports = planning;



// WEBPACK FOOTER //
// ./models/cpm/planning.js